import { createApp } from "vue";
import App from "./App.vue";
import { createPinia } from "pinia";

import router from "./router";
import store from "./store"; // لو لسة مش محتاج ممكن تشيله
import i18n from "./i18n";

import "./assets/tailwind.css";

// 1 إنشاء الـ app
const app = createApp(App);

// 2إنشاء Pinia
const pinia = createPinia();

// 3 استخدام الـ plugins
app.use(pinia);
app.use(store); // لو محتاج Vuex legacy
app.use(router);
app.use(i18n);

// 4Mount
app.mount("#app");
